import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061dd239"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "dcdTitle" }, "Demo Car Deduction Set", -1))
const _hoisted_2 = { style: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    } }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Generate Deduction File ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"color":"red","margin-top":"12px"} }, "Note:The input information will take into demo car deduction file name.", -1))

import { createVNode, ref, } from "vue";
import { getReleaseListApi, generateFileApi } from "@/API/payment";
import { Modal, message } from "ant-design-vue";
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["set"],
  setup(__props, { expose, emit }: { emit: ({
  (event: 'set'): void
}), expose: any, slots: any, attrs: any }) {



const state = ref<any>({
  selectedRowKeys: [],
  data: [],
  loading: false,
  visible: false,
  innerModal: false,
  period: '',
  entity: '',
  payoutRound: ''
});
const onSelectChange = (selectedRowKeys: any[]) => {
  state.value.selectedRowKeys = selectedRowKeys;
}
const columns = ref([{
  title: 'Payout Round',
  key: 'payoutRound',
  dataIndex: 'payoutRound'
}])

async function getReleaseRound(payoutRound: any, entity: any) {
  state.value.selectedRowKeys = []
  state.value.payoutRound = payoutRound
  state.value.entity = entity
  const res = await getReleaseListApi(payoutRound, entity);
  state.value.data = res
  res.forEach((item: any) => {
    if (item.checked) {
      state.value.selectedRowKeys.push(item.payoutRound)
    }
  })
  setTimeout(()=>{
    state.value.visible = true
  })
}

function generateOrNo() {
  if (state.value.selectedRowKeys.length === 0) {
    Modal.confirm({
      title: 'No item selected, deduction file will discard!',
      icon: createVNode(ExclamationCircleOutlined),
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        await generateFile()
        emit('set')
      }
    });
  } else {
    state.value.innerModal = true
  }
}

async function innerOk() {
  if (state.value.period == '') {
    message.error('Please input release file period!')
    return
  }
  await generateFile()
  emit('set')
}
function innerCancel() {
  state.value.period = ''
}

async function generateFile() {
  try {
    await generateFileApi({
      entity: state.value.entity,
      triggerPayoutRound: state.value.payoutRound,
      releaseFilePeriod: state.value.period,
      releaseRoundsOfTriggerPayoutRound: state.value.selectedRowKeys
    })
  } finally {
    close()
  }
  
}

function close() {
  state.value = {
    selectedRowKeys: [],
    data: [],
    loading: false,
    visible: false,
    innerModal: false,
    period: '',
    entity: '',
    payoutRound: ''
  }
}

expose({
  getReleaseRound
})

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_drawer, {
      title: "Set",
      closable: true,
      visible: state.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((state.value.visible) = $event)),
      width: 400
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_table, {
          class: "data-table",
          "row-selection": { selectedRowKeys: state.value.selectedRowKeys, onChange: onSelectChange },
          columns: columns.value,
          pagination: false,
          dataSource: state.value.data,
          rowKey: "payoutRound"
        }, null, 8, ["row-selection", "columns", "dataSource"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"8px"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: generateOrNo
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: state.value.innerModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((state.value.innerModal) = $event)),
      onCancel: innerCancel,
      onOk: innerOk,
      okText: 'Confirm'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: state.value.period,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.value.period) = $event)),
          placeholder: "Input release file period",
          style: {"width":"90%"}
        }, null, 8, ["value"]),
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})